/**
 * Security utilities to prevent clickjacking and other attacks
 */

// Check if the page is being loaded in an iframe
export const checkIfInIframe = (): boolean => {
  try {
    return window !== window.top;
  } catch (e) {
    return true; // If we can't access window.top, we're likely in an iframe
  }
};

// Prevent clickjacking by breaking out of iframes
export const preventClickjacking = (): void => {
  if (checkIfInIframe()) {
    // Break out of iframe
    try {
      if (window.top && window.top !== window) {
        window.top.location.href = window.location.href;
      }
    } catch (e) {
      // If we can't access window.top due to same-origin policy or other restrictions,
      // we'll use alternative methods or just log the attempt
      console.warn('Clickjacking protection: Unable to break out of iframe due to security restrictions');
      
      // Alternative: Hide the page content if in iframe
      document.body.style.display = 'none';
      
      // Show a warning message
      const warning = document.createElement('div');
      warning.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #ff4444;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        z-index: 999999;
        text-align: center;
        padding: 20px;
      `;
      warning.innerHTML = `
        <div>
          <h2>⚠️ Security Warning</h2>
          <p>This page should not be displayed in an iframe for security reasons.</p>
          <p>Please open this page directly in your browser.</p>
        </div>
      `;
      document.body.appendChild(warning);
    }
  }
};

// Additional security checks
export const securityChecks = (): void => {
  // Prevent clickjacking
  preventClickjacking();
  
};

// Initialize security measures
export const initSecurity = (): void => {
  // Run security checks immediately
  securityChecks();
  
  // Also run on DOM content loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', securityChecks);
  }
}; 